
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiHandlerService } from 'src/app/shared/services/api-handler.service';
import { CmnFunctionService } from 'src/app/shared/services/cmn-function.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public currentUseInfo: any = {};
  constructor(
    public cmnFunction: CmnFunctionService,
    public service: ApiHandlerService,
    public toaster: ToasterService,
    public storage: StorageService,
    public router: Router
  ) { }

  ngOnInit() {
    this.cmnFunction.userInfo.subscribe(data => {
      if (data) {
        this.currentUseInfo.name = data.name;
        this.currentUseInfo.image = data.image;
        this.currentUseInfo.role = data.role;
      } else {
        if (JSON.parse(localStorage.getItem('userData')) != null) {
          this.currentUseInfo.name = JSON.parse(localStorage.getItem('userData')).name;
          this.currentUseInfo.image = JSON.parse(localStorage.getItem('userData')).image;
          this.currentUseInfo.role = JSON.parse(localStorage.getItem('userData')).role;
        }
      }
    })
  }

  //LogoutUser function for logout user from app..
  LogoutUser() {
    //apiPost function for post data to Db...
    this.service.apiGet(this.service.baseUrl + 'logout').subscribe({
      next: result => {
        if (result.status) {
          this.storage.deleteUserToken();
          this.storage.DeleteUserStorageData();
          this.toaster.Success(result.message);

          this.cmnFunction.userInfo.next(null);
          //redirect to cutomer page
          this.router.navigate(['auth/login']);
        } else {
          this.toaster.Error(result.message);
        }
      },
      error: err => {
        let msg = (err.error && err.error.message) ? err.error.message : 'Invalid Credentials';
        //this.loginForm.reset();
        //this.toasterService.Error(msg);
        this.toaster.Error(msg);
      },
      complete: () => { }
    });
  }


  getUserDetails() {
    //apiPost function for post data to Db...
    this.cmnFunction.getUserDetails().subscribe(data => {
      if (data) {
        this.currentUseInfo = data.data;
      }
    });
  }

}
